
/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { useEffect } from 'react';
import Analytics from '@web-solutions/module-analytics';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.wrapperInfo}>
        <Title className={styles.title}>{t('onboarding.individualApproach.title')}</Title>
        <Text semibold className={styles.description}>
          {t('onboarding.individualApproach.subTitle1')}{' '}
          <span>{t('onboarding.individualApproach.subTitle2')}</span>
        </Text>
        <div className={styles.image}></div>
      </div>
      <div className={styles.continue}>
        <div className={styles.blur}></div>

        <Button
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'individual-approach',
            });
            onNext();
          }}
          title={t('onboarding.individualApproach.increaseFit')}
        />
      </div>
    </div>
  );
}

export default Page;
